<div class="bg-primary-200 text-center py-60 min-vh-100">
  <div class="heading-1 text-primary-0 mt-20 pt-60 pb-20">¡OH NO!</div>
  <div class="heading-4 text-white">
    {{ message }}
    <br />
    {{ action }}
  </div>
  <img class="py-30" src="assets/auth-error.png" />
</div>
